"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterToSFUEvent = exports.ZodAVSFUGetPlayerDataMessageResponse = exports.ZodAVSFUProduceResumeMessageData = exports.ZodAVSFUProducePauseMessageData = exports.ZodAVSFUDebugConsumerMessageData = exports.ZodAVSFUDebugMessageData = exports.ZodRemoteLogData = exports.ZodAVSFUProduceCloseMessageData = exports.ZodAVSFUConsumeRequestMessageData = exports.ZodAVSFUConsumeCreatedMessageData = exports.ZodAVSFUConsumeAllowMessageData = exports.ZodAVSFUSetConsumeSpatialMessageData = exports.ZodAVSFUSetConsumePriorityMessageResponse = exports.ZodAVSFUSetConsumePriorityMessageData = exports.ZodAVSFUConsumeManipulationMessageData = exports.ZodAVSFUConsumeMessageData = exports.ZodAVSFUProduceMessageData = exports.ZodAVSFURestartIceMessageData = exports.ZodAVSFUTransportRestartMessageData = exports.ZodAVSFUTransportCloseMessageData = exports.ZodAVSFUTransportCreateMessageData = exports.ZodAVSFUTransportConnectMessageData = void 0;
const zod = __importStar(require("zod"));
const common_1 = require("./common");
const ZodVideoSpatialLayer = zod.nativeEnum(common_1.VideoSpatialLayer);
exports.ZodAVSFUTransportConnectMessageData = zod.object({
    transportId: zod.string(),
    dtlsParameters: zod.any(),
});
exports.ZodAVSFUTransportCreateMessageData = zod
    .object({
    direction: common_1.ZodTransportDirection,
    iceTransportRequestOptions: common_1.ZodIceTransportRequestOptions.optional(),
})
    .nullable();
exports.ZodAVSFUTransportCloseMessageData = zod.object({
    transportId: zod.string(),
});
exports.ZodAVSFUTransportRestartMessageData = zod.object({
    transportId: zod.string(),
});
exports.ZodAVSFURestartIceMessageData = zod.object({
    transportId: zod.string(),
    iceTransportRequestOptions: common_1.ZodIceTransportRequestOptions.optional(),
});
exports.ZodAVSFUProduceMessageData = zod.object({
    transportId: zod.string(),
    tag: common_1.ZodConsumerKind,
    kind: zod.any(),
    rtpParameters: zod.any(),
    highQualityScreenShare: zod.boolean().optional(),
});
exports.ZodAVSFUConsumeMessageData = zod.object({
    transportId: zod.string(),
    srcId: zod.string(),
    srcStreamId: zod.string(),
    tag: common_1.ZodConsumerKind,
    rtpCapabilities: zod.any(),
    spatialLayer: ZodVideoSpatialLayer.optional(),
});
exports.ZodAVSFUConsumeManipulationMessageData = zod.object({
    srcId: zod.string(),
    srcStreamId: zod.string(),
    tag: common_1.ZodConsumerKind,
    consumerId: zod.string(),
});
exports.ZodAVSFUSetConsumePriorityMessageData = zod.object({
    srcStreamId: zod.string(),
    tag: common_1.ZodConsumerKind,
    srcIds: zod.string().array(),
});
exports.ZodAVSFUSetConsumePriorityMessageResponse = zod.object({
    result: zod
        .object({
        srcId: zod.string(),
        priority: zod.number(),
    })
        .array(),
});
exports.ZodAVSFUSetConsumeSpatialMessageData = zod.object({
    srcId: zod.string(),
    srcStreamId: zod.string(),
    tag: common_1.ZodConsumerKind,
    spatialLayer: zod.number(),
    temporalLayer: zod.number().optional(),
});
exports.ZodAVSFUConsumeAllowMessageData = zod.object({
    dstId: zod.string(),
    dstStreamId: zod.string().optional(),
    allowed: zod.boolean(),
});
exports.ZodAVSFUConsumeCreatedMessageData = zod.object({
    srcId: zod.string(),
    srcStreamId: zod.string(),
    tag: common_1.ZodConsumerKind,
    consumerId: zod.string(),
});
exports.ZodAVSFUConsumeRequestMessageData = zod.object({
    srcId: zod.string(),
    srcStreamId: zod.string(),
    requested: zod.boolean(),
});
exports.ZodAVSFUProduceCloseMessageData = zod.object({
    tag: common_1.ZodConsumerKind,
});
exports.ZodRemoteLogData = zod.object({
    message: zod.string(),
});
exports.ZodAVSFUDebugMessageData = zod.object({
    srcIds: zod.string().array(),
    srcStreamId: zod.string(),
});
exports.ZodAVSFUDebugConsumerMessageData = zod.object({
    srcId: zod.string(),
    srcStreamId: zod.string(),
    tags: common_1.ZodConsumerKind.array(),
});
exports.ZodAVSFUProducePauseMessageData = zod.object({
    tag: common_1.ZodConsumerKind,
});
exports.ZodAVSFUProduceResumeMessageData = zod.object({
    tag: common_1.ZodConsumerKind,
});
exports.ZodAVSFUGetPlayerDataMessageResponse = zod.object({
    transports: zod
        .object({
        id: zod.string(),
        direction: common_1.ZodTransportDirection,
    })
        .array()
        .optional(),
    producers: zod
        .object({
        id: zod.string(),
        kind: common_1.ZodConsumerKind,
        paused: zod.boolean().optional(),
    })
        .array()
        .optional(),
    subscriptions: zod
        .object({
        playerId: zod.string(),
        consumers: zod
            .object({
            id: zod.string(),
            kind: common_1.ZodConsumerKind,
            producerPaused: zod.boolean().optional(),
        })
            .array(),
    })
        .array()
        .optional(),
    allowedConsume: zod.string().array().optional(),
});
var RouterToSFUEvent;
(function (RouterToSFUEvent) {
    RouterToSFUEvent["ForceTerminate"] = "force-terminate";
})(RouterToSFUEvent || (exports.RouterToSFUEvent = RouterToSFUEvent = {}));
//# sourceMappingURL=toSFU.js.map